import '@utils/development'

import Vue from 'vue'
import 'babel-polyfill'

import App from './App'
import router from '@router'
import i18n from '@lang'
import store from '@store'

import '@components/_globals'

import '@plugins/ga'
import '@plugins/vue-gtag'
import '@plugins/clipboard'
import '@plugins/element'
import '@plugins/fontawesome'
import '@plugins/vee-validate'
import '@plugins/wow-animate'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

if(process.env.NODE_ENV === 'development'
  || window.globalData.APP_ENV === 'local'
  || window.globalData.APP_ENV === 'staging'
) {
  app.$root.IS_DEVELOPMENT = true;
}

if(window.globalData.APP_ENV === 'production') {
  app.$root.IS_OFFICIAL = true;
}

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
